<template>
  <v-app :site-key="globalSiteKey">
    <Drawer :drawer.sync="drawer" :mini.sync="mini"></Drawer>
    <v-app-bar app clipped-left color="primary" dark>
      <v-app-bar-nav-icon @click="toggleSideMenu"></v-app-bar-nav-icon>
      <v-toolbar-title
        >Регион контент
        <!--        <v-menu>-->
        <!--          <template v-slot:activator="{ on }">-->
        <!--            <span v-on="on">Регион контент </span>-->
        <!--          </template>-->
        <!--          <v-list>-->
        <!--            <v-list-item-->
        <!--              v-for="(item, index) in contentScopes"-->
        <!--              :key="index"-->
        <!--              @click="onScopeClick(item)"-->
        <!--            >-->
        <!--              <v-list-item-title>{{ item.title }}</v-list-item-title>-->
        <!--            </v-list-item>-->
        <!--          </v-list>-->
        <!--        </v-menu>-->
        {{ subTitle }}
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn
        dark
        text
        v-show="isEditor || isSuperuser"
        @click="selectSiteDialog = !selectSiteDialog"
      >
        Выбрать сайт
        <v-icon color="white" right>mdi-earth</v-icon>
      </v-btn>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn dark text @click="logout" v-on="on">
            {{ userName }}
            <v-icon color="white" right>mdi-logout</v-icon>
          </v-btn>
        </template>
        <span>выйти</span>
      </v-tooltip>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <router-view name="main_content" :site_key="globalSiteKey" :site_title="globalSiteTitle" />
      </v-container>
      <SnackBar></SnackBar>
    </v-main>
    <v-dialog v-model="selectSiteDialog" max-width="600">
      <v-card class="pa-6">
        <v-card-text>
          <SiteSelect :site="globalSiteKey" @site-selected="siteSelected"></SiteSelect>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import SiteSelect from '@/components/SiteSelect'
import SnackBar from '@/components/SnackBar'
import Drawer from '@/components/Drawer'
import user from '@/mixins/user'
import { Scope, ScopeItems } from '@/api/consts'

const defaultSnackbar = {
  color: '',
  message: '',
  timeout: 5000,
  show: false,
}
export default {
  name: 'Main',
  components: { Drawer, SiteSelect, SnackBar },
  mixins: [user],
  meta: {
    title: 'Регион контент',
  },
  data() {
    return {
      drawer: true,
      mini: false,
      site: '',
      globalSiteKey: '',
      globalSiteTitle: '',
      globalSite: {},
      selectSiteDialog: false,
      snackbar: { ...defaultSnackbar },
      timerId: null,
      contentScope: Scope.RegionContent,
      contentScopes: [...ScopeItems],
    }
  },
  computed: {
    userName() {
      return this.$store.state.auth.user.name
    },
    subTitle() {
      return this.globalSiteTitle ? '| ' + this.globalSiteTitle : ''
    },
  },
  mounted() {
    this.$on('site-selected', this.siteSelected)
    this.$on('show-site-selected', () => (this.selectSiteDialog = true))
    this.globalSiteKey = localStorage.getItem('user-region') || ''
    this.globalSiteTitle = localStorage.getItem('user-region-title') || ''
  },
  beforeDestroy() {
    this.$off('site-selected', this.siteSelected)
    this.$off('show-site-selected')
  },
  methods: {
    onScopeClick(item) {
      this.$emit('scope:update', item)
      this.contentScope = { ...item }
    },
    siteSelected(e) {
      if (e.key === this.globalSiteKey) {
        return
      }
      this.$log.debug('app site selected', e)
      this.globalSiteKey = e.key
      this.selectSiteDialog = false
      this.globalSiteTitle = e.title
      this.globalSite = e
    },
    toggleSideMenu() {
      this.drawer = !this.drawer
      this.mini = !this.mini
    },
    logout() {
      this.$store.dispatch('AUTH_LOGOUT').then(() => {
        this.$localStorage.set('user-region', '')
        this.$localStorage.set('user-region-title', '')
        localStorage.removeItem('user-region')
        localStorage.removeItem('user-region-title')
        this.$router.push({ name: 'login', query: { next: this.$route.path } })
      })
    },
    toImages() {
      this.$router.push({ name: 'images' })
    },
  },
}
</script>
